import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from '../store'
import {
  postCybozuSync,
  postCybozuLink,
  postCybozuDisassociation,
} from '../../apis/setting'
import { setErrors } from '../common/errorsSlice'
import {
  CybozuSyncResponse,
  CybozuCallbackUrl,
} from '../../types/setting'

export interface CybozuSyncState extends CybozuSyncResponse {
  isSucceeded: boolean | null
}

const initialState: CybozuSyncState = {
  login_url: "",
  isSucceeded: null,
}

const cybozuSyncSlice = createSlice({
  name: 'cybozuSync',
  initialState,
  reducers: {
    requestStart: (state) => state,
    postCybozuSyncSuccess: (state, action: PayloadAction<CybozuSyncResponse>) => {
      state.login_url = action.payload.login_url
      state.isSucceeded = true
      return state
    },
    postCybozuLinkSuccess: (state) => {
      state.isSucceeded = true
    },
    requestFailure: (state) => {
      state.isSucceeded = false
      return state
    },
  },
})

export const {
  requestStart,
  postCybozuSyncSuccess,
  postCybozuLinkSuccess,
  requestFailure,
} = cybozuSyncSlice.actions

export const cybozuSyncReducer = cybozuSyncSlice.reducer

export const createCybozuSync = (
  callback: (cybozu: CybozuSyncState) => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postCybozuSync()
    .then((result) => {
      dispatch(postCybozuSyncSuccess(result))
      callback(result)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createCybozuLink = (
  params: CybozuCallbackUrl,
  callback: (result: boolean) => void,
  errorCallback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postCybozuLink(params)
    .then(() => {
      dispatch(postCybozuLinkSuccess())
      callback(true)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
      errorCallback()
    })
}

export const deleteCybozuSync = (
  callback: (cybozu: CybozuSyncState) => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postCybozuDisassociation()
    .then((result) => {
      dispatch(postCybozuSyncSuccess({ login_url: '' }))
      callback(result)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}
